export default function addTrailingSlash(url?: string): string {
    if (typeof url === 'undefined' || !url.length) {
        return ''
    }

    if (url.length && url.endsWith('/')) {
        return url
    }

    return `${url}/`
}
